import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CarouselButton from '@cotyorg/ccx-organism-carousel/components/CarouselButton';
import Pagination from '../Pagination/index';

const CarouselControls = ({
  carouselsStoreDataKey,
  buttons,
  pagination,
  currentIndex,
  noOfPages,
  setIndex,
  pageIds,
  rightChevronIconSrc,
  leftChevronIconSrc,
  onIndexChange,
  infinite,
  showPagination,
  sliderRef,
}) => {
  if (noOfPages === 1) {
    return null;
  }

  return (
    <>
      <CarouselButton
        carouselsStoreDataKey={carouselsStoreDataKey}
        direction="backward"
        setIndex={setIndex}
        currentIndex={currentIndex}
        leftChevronIconSrc={leftChevronIconSrc}
        onIndexChange={onIndexChange}
        noOfPages={noOfPages}
        infinite={infinite}
        showPagination={showPagination}
        testAttribute="carousel-pagination-backward"
        {...buttons}
      />
      <CarouselButton
        carouselsStoreDataKey={carouselsStoreDataKey}
        direction="forward"
        setIndex={setIndex}
        currentIndex={currentIndex}
        rightChevronIconSrc={rightChevronIconSrc}
        onIndexChange={onIndexChange}
        noOfPages={noOfPages}
        infinite={infinite}
        showPagination={showPagination}
        testAttribute="carousel-pagination-forward"
        {...buttons}
      />
      {showPagination && (
        <Pagination
          carouselsStoreDataKey={carouselsStoreDataKey}
          currentIndex={currentIndex}
          setIndex={setIndex}
          noOfPages={noOfPages}
          pageIds={pageIds}
          onIndexChange={onIndexChange}
          {...pagination}
          sliderRef={sliderRef}
        />
      )}
    </>
  );
};

CarouselControls.propTypes = {
  carouselsStoreDataKey: PropTypes.string.isRequired,
  buttons: PropTypes.objectOf(PropTypes.any),
  pagination: PropTypes.objectOf(PropTypes.any),
  currentIndex: PropTypes.number.isRequired,
  noOfPages: PropTypes.number.isRequired,
  setIndex: PropTypes.func.isRequired,
  pageIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  rightChevronIconSrc: PropTypes.string,
  leftChevronIconSrc: PropTypes.string,
  onIndexChange: PropTypes.func,
  infinite: PropTypes.bool,
  showPagination: PropTypes.bool,
  sliderRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

export default CarouselControls;
